import {Injectable, signal} from '@angular/core';
import {NonNullableFormBuilder} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {AdxErpPanelFilterForm, AdxErpPanelFilterModel} from '../models/adx-erp-panel-filter-model';

@Injectable({
  providedIn: 'root'
})
export class AdxErpPanelFilterService {
  public readonly toggleModal = signal(false);

  public readonly filtersValue = signal<AdxErpPanelFilterModel>(this.buildDefaultFilters());

  private readonly filters$ = new BehaviorSubject<AdxErpPanelFilterModel>(this.filtersValue());

  public get form(): AdxErpPanelFilterForm {
    return this.formBuilder.group({
      AdxInvoiceId: [null as number | null],
      RecordLocator: [null as string | null],
      ErpOrderNumber: [null as string | null],
      ClientName: [null as string | null],
      CreatedDateFrom: [null as Date | null],
      CreatedDateTo: [null as Date | null],
      ErpSentDateFrom: [null as Date | null],
      ErpSentDateTo: [null as Date | null],
      ErpResponseDateFrom: [null as Date | null],
      ErpResponseDateTo: [null as Date | null],
      IsMor: [null as boolean | null],
      TravelTypeId: [null as number | null],
      ExternalTravelServiceTypeId: [null as number | null],
      VendorName: [null as string | null],
      AgentName: [null as string | null],
      DataSourceId: [null as number | null],
      InvoiceGroup: [null as string | null],
    });
  }

  constructor(private readonly formBuilder: NonNullableFormBuilder) {}

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: AdxErpPanelFilterModel) {
    this.filters$.next(value);
    this.filtersValue.set(value);
  }

  private buildDefaultFilters(): AdxErpPanelFilterModel {
    return {
      AdxInvoiceId: null,
      RecordLocator: null,
      ErpOrderNumber: null,
      ClientName: null,
      CreatedDateFrom: null,
      CreatedDateTo: null,
      ErpSentDateFrom: null,
      ErpSentDateTo: null,
      ErpResponseDateFrom: null,
      ErpResponseDateTo: null,
      IsMor: null,
      TravelTypeId: null,
      ExternalTravelServiceTypeId: null,
      VendorName: null,
      AgentName: null,
      DataSourceId: null,
      InvoiceGroup: null,
      ReloadGrid: false,
    };
  }
}
